export function QuoteIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg className={className} width="9" height="7" viewBox="0 0 9 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_2645_20239)">
        <g opacity="0.2">
          <rect y="3" width="4" height="4" fill="#101828" />
          <path d="M1.8 0L0 3H2.4L3 0H1.8Z" fill="#101828" />
          <rect x="5" y="3" width="4" height="4" fill="#101828" />
          <path d="M6.8 0L5 3H7.4L8 0H6.8Z" fill="#101828" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2645_20239">
          <rect width="9" height="7" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

QuoteIcon.displayName = 'QuoteIcon';